export default "__VITE_ASSET__Dlc435S8__"